// extracted by mini-css-extract-plugin
export var container = "Popup-module--container--28c44";
export var cross = "Popup-module--cross--f4b8e";
export var modal = "Popup-module--modal--4c3a6";
export var overlay = "Popup-module--overlay--dd9c3";